var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLuggage7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    fill: "current",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M358.4 230.4a76.8 76.8 0 0 0-76.8 76.8v409.6a76.8 76.8 0 0 0 76.8 76.8h307.2a76.8 76.8 0 0 0 76.8-76.8V307.2a76.8 76.8 0 0 0-76.8-76.8H358.4z m0-51.2h307.2a128 128 0 0 1 128 128v409.6a128 128 0 0 1-128 128H358.4a128 128 0 0 1-128-128V307.2a128 128 0 0 1 128-128z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M384 230.0416h-51.2V174.3872C332.8 121.984 364.9536 76.8 409.6 76.8h204.8c44.6464 0 76.8 45.184 76.8 97.5872v46.08h-51.2v-46.08C640 147.2512 626.304 128 614.4 128h-204.8c-11.904 0-25.6 19.2512-25.6 46.3872v55.6544zM358.4 844.8a25.6 25.6 0 0 1 51.2 0v51.2a25.6 25.6 0 0 1-51.2 0v-51.2zM614.4 844.8a25.6 25.6 0 0 1 51.2 0v51.2a25.6 25.6 0 0 1-51.2 0v-51.2z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M369.3824 387.6608a25.6 25.6 0 0 1 51.2 0v298.368a25.6 25.6 0 0 1-51.2 0V387.6608zM486.4 387.6608a25.6 25.6 0 0 1 51.2 0v298.368a25.6 25.6 0 0 1-51.2 0V387.6608zM603.4176 387.6608a25.6 25.6 0 1 1 51.2 0v298.368a25.6 25.6 0 0 1-51.2 0V387.6608z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuggage7);
export default __webpack_public_path__ + "static/media/luggage-7.fa838ae63f21b3cc206e638edece5503.svg";
export { ForwardRef as ReactComponent };